module.exports = __webpack_public_path__ + "img/f3.9d1b61b2.png";